import ThrowsValidationError from "common/http/throwsValidationError";
import HttpService from "common/http/httpService";

class ContractSignatureService extends HttpService {
    @ThrowsValidationError()
    async requestContractSignature(contractId: string, communication: RequestContractSignatureRequest): Promise<string> {
        const response = await this.getClient().postForm<string>(`offers/v1/contracts/${contractId}/request-signature`, communication);
        return response.data
    }
}

const contractSignatureService = new ContractSignatureService();

export interface RequestContractSignatureRequest {
    contractFile: File;
}

export default contractSignatureService;